var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobileRotation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M494.9,198.8c0-11.5-4.5-22.5-12.7-30.6L343.7,29.7c-8.1-8.1-19-12.7-30.5-12.7h-0.1 c-11.4,0-22.3,4.5-30.3,12.7L29.7,282.8c-16.8,16.7-16.9,43.9-0.2,60.7c0.1,0.1,0.1,0.1,0.2,0.2l138.5,138.6 c8.1,8.1,19,12.7,30.5,12.7h0.1c11.4,0,22.3-4.5,30.3-12.7l253.1-253.1C490.4,221.1,494.9,210.2,494.9,198.8z M470.2,217.1 L470.2,217.1L217.1,470.2c-4.8,4.9-11.4,7.7-18.3,7.7l0,0c-6.9,0-13.5-2.8-18.4-7.7L41.8,331.7c-10.1-10.1-10.2-26.5-0.1-36.6 c0,0,0.1-0.1,0.1-0.1L294.9,41.8c4.8-4.9,11.4-7.7,18.3-7.7h0c6.9,0,13.5,2.8,18.4,7.7l138.6,138.5c10.1,10.1,10.2,26.5,0.1,36.6 C470.3,217,470.2,217,470.2,217.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M314.6,64.7c-6.7-6.6-17.4-6.6-24.1,0L75.3,280c-6.7,6.5-6.8,17.2-0.3,23.9c0.1,0.1,0.1,0.2,0.2,0.2 l132.5,132.5c3.2,3.3,7.6,5.1,12.1,5.1l0,0c4.5,0,8.9-1.8,12-5l215.4-215.3c6.6-6.7,6.6-17.4,0-24.1L314.6,64.7z M219.9,424.7 L87.3,292.1L302.5,76.8l132.7,132.7L219.9,424.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M121.5,369.7c-3.3-3.4-8.7-3.5-12.1-0.2c-3.4,3.3-3.5,8.7-0.2,12.1c0.1,0.1,0.1,0.1,0.2,0.2l20.8,20.8 c3.4,3.3,8.8,3.2,12.1-0.2c3.2-3.3,3.2-8.5,0-11.9L121.5,369.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M223.7,2.6c-3.7-0.7-90.4-18.7-147,49.6c-34.3,41.4-41.4,89.3-42.4,132.2l-19.7-19.7c-3.3-3.3-8.7-3.3-12.1,0 c-3.3,3.3-3.3,8.7,0,12.1c0,0,0,0,0,0l34.1,34.1c3.3,3.3,8.7,3.3,12.1,0l34.1-34.1c3.3-3.4,3.2-8.8-0.2-12.1 c-3.3-3.2-8.5-3.2-11.9,0L51.4,184c1-39.8,7.6-83.7,38.5-121c49.8-60.1,129.5-43.9,130.2-43.8c4.6,1,9.2-1.9,10.2-6.6 S228.3,3.6,223.7,2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M475.4,301.2c-3.3-3.3-8.7-3.3-12.1,0l-34.1,34.1c-3.3,3.4-3.2,8.8,0.2,12.1c3.3,3.2,8.6,3.2,11.9,0l19.4-19.4 c-1,39.8-7.6,83.7-38.5,121c-49.8,60.1-129.4,43.9-130.2,43.8c-4.6-1-9.1,1.9-10.1,6.5c-1,4.6,1.9,9.1,6.5,10.1 c9.9,1.9,19.9,2.8,30,2.7c44.9,1.2,87.9-18,117-52.3c34.3-41.4,41.4-89.3,42.4-132.2l19.7,19.7c3.4,3.3,8.8,3.2,12.1-0.2 c3.2-3.3,3.2-8.6,0-11.9L475.4,301.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileRotation);
export default __webpack_public_path__ + "static/media/mobile-rotation.65f569ee73f83bf262712d6b5505036b.svg";
export { ForwardRef as ReactComponent };